<app-upload-dropzone-border>
  <div class="mx-auto flex flex-col items-center p-14 text-center">
    <span class="font-medium text-blue-500"> Kliknij, aby wybrać plik </span>
    <span>lub</span>
    <span class="font-medium">upuść plik tutaj, aby go przesłać</span>
    <span class="text-sm font-medium text-gray-500">
      Maksymalna wielkość dodawanego pliku: {{ maxFileSize | filesize }}.
    </span>
  </div>
</app-upload-dropzone-border>
